/**
 * Clients read service — search EXISTING control-plane clients so onboarding can LINK a project to
 * an already-registered client instead of creating a duplicate (ADR-0001: one Client per company,
 * `country` = HQ, N BillingIdentities per legal entity). Domain-restricted read per Security Rules.
 */
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import type { Client } from '../types/entities';

/** Existing clients whose canonical_name contains `query` (case-insensitive). Small dataset — read all,
 *  filter client-side. Returns the top matches for a "use existing" picker. */
export async function searchClients(query: string): Promise<Client[]> {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const snap = await getDocs(collection(db, 'clients'));
  return snap.docs
    .map((d) => d.data() as Client)
    .filter((c) => (c.canonical_name ?? '').toLowerCase().includes(q))
    .sort((a, b) => (a.canonical_client_id ?? '').localeCompare(b.canonical_client_id ?? ''))
    .slice(0, 8);
}
